import { apiClient } from "@base/api/client";
import type { RemainingMinutesResponse } from "@features/reservation/model/types";

/**
 * GET /82office/resource/api/remaining-minutes
 * 미팅룸 무료 사용 시간 조회 (Subscription이 없는 회사는 0, 0 반환)
 */
export async function fetchRemainingMinutes(): Promise<RemainingMinutesResponse> {
  const { data } = await apiClient.get<RemainingMinutesResponse>("/82office/resource/api/remaining-minutes");
  return data;
}

/*
 * TanStack Query 사용 예시:
 *
 * import { useQuery } from "@tanstack/react-query";
 * import { fetchRemainingMinutes } from "@features/reservation/api/remainingMinutes";
 *
 * const { data } = useQuery({
 *   queryKey: ["remainingMinutes"],
 *   queryFn: fetchRemainingMinutes,
 * });
 */
